import React from "react";
import "../contact/contact.css";
import contacts from "./data";

const Contact = () => {
  return (
    <section id="contact">
      <h2>Contactez-moi</h2>
      {/* Updated text to reflect both email and phone */}
      <p>Envoyez-moi un message ou appelez-moi grâce aux liens ci-dessous.</p>
      <div className="container contact__container" data-aos="fade-up">
        {contacts.map((contact) => (
          <a
            key={contact.contactId}
            href={contact.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {contact.icon}
          </a>
        ))}
      </div>
    </section>
  );
};

export default Contact;